import { useQuery } from '@apollo/client';
import { Navigate, useParams } from 'react-router-dom';

import { Loader } from '../../../components/common/Loader';
import { getFragment } from '../../../graphql';
import { GetPrescriberOrderDocument } from '../../../graphql/generated/graphql';
import { useFlags } from '../../../hooks/use-flags';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';

import { RenewalStatus } from './RenewalStatus';

const RenewalStatusPage = () => {
    const { prescriberOrderId } = useParams();
    const { enableRxRenewalMyphx } = useFlags();
    const { data, loading } = useQuery(GetPrescriberOrderDocument, {
        variables: { prescriberOrderId: prescriberOrderId ?? '' },
        skip: !prescriberOrderId,
    });

    if (!enableRxRenewalMyphx) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    if (loading) {
        return <Loader />;
    }

    if (!prescriberOrderId) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    const prescriberOrder = getFragment(data?.prescriberOrder);
    if (!prescriberOrder) {
        return <Navigate to={getAbsoluteRoute('notFound')} />;
    }

    if (prescriberOrder.__typename !== 'DigitallyReceivedPrescriberOrder') {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    return <RenewalStatus prescriberOrder={prescriberOrder} />;
};

export default RenewalStatusPage;
